import overlays from '@/mixins/overlays'
import { AxiosError } from 'axios'
import { TranslateResult } from 'vue-i18n'
import { Location } from 'vue-router'
import { isEqual } from 'lodash'
export default overlays.extend({
  computed: {
    navigate (): Function {
      const handler = async (to: Location) => {
        if (this.$route.name !== to.name) {
          await this.$router.push(to)
        }
        else if (to.query && !isEqual(this.$route.query, to.query)) {
          await this.$router.push({
            query: to.query
          })
        }
      }
      return this.offlineWrapper(handler)
    }
  },
  methods: {
    offlineWrapper (fn: any) {
      return this.basicWrapper(fn, this.$t('errors.offline'))
    },
    basicWrapper (fn: any, errorMessage?: TranslateResult) {
      const $self = this
      return async function (...args: any) {
        try {
          await $self.$store.dispatch('app/TestNetworkConnection')
          return await fn.call($self, ...args)
        }
        catch (error) {
          const message = (error as AxiosError).isAxiosError
            ? $self.$t('errors.backend')
            : errorMessage || error.message
          $self.showSnackbar(message, { timeout: 5000 })
          throw error
        }
      }
    }
  }
})
